import { createTheme, PaletteOptions, styled } from "@mui/material/styles";
import { ptBR } from "@mui/material/locale";
import { ptBR as ptBRDataPicker } from "@mui/x-date-pickers/locales";
import "./DatePickerDisabled.css";
import { buildLightPalette } from "./palette/light";
import { buildDarkPalette } from "./palette/dark";
import { defaultTenantPalette, TenantPalette } from "./palette/tokens";
import { loginPalette } from "./palette/login";
import { typography } from "./typography";
import { getComponentOverrides } from "./components";

export const StyledCKEditorWrapper = styled("div")(({ theme }) => ({
  "& .ck.ck-content": {
    minHeight: 240,
    padding: theme.spacing(2),
    backgroundColor: `${theme.palette.background.paper} !important`,
    borderRadius: theme.shape.borderRadius,
    color: `${theme.palette.text.secondary} !important`,
    fontFamily: theme.typography.fontFamily,
    border: `1px solid ${theme.palette.divider}`,

    "&.ck-placeholder::before": {
      color: theme.palette.text.disabled,
    },

    "&.ck-focused": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: "2px",
    },
  },

  "& .ck.ck-menu-bar": {
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    color: theme.palette.primary.contrastText,
  },

  "& .ck.ck-menu-bar .ck-button": {
    color: theme.palette.primary.contrastText,
    background: "transparent",
    borderRadius: theme.shape.borderRadius,
    transition: "background 0.2s ease-in-out",
  },

  "& .ck.ck-toolbar": {
    backgroundColor: theme.palette.primary.main,
  },

  "& .ck.ck-list": {
    backgroundColor: theme.palette.primary.main,
  },

  "& .ck.ck-button": {
    backgroundColor: theme.palette.primary.main,
  },

  "& .ck.ck-color-grid": {
    backgroundColor: theme.palette.secondary.main,
  },

  "& .ck.ck-style-panel": {
    backgroundColor: theme.palette.primary.main,
  },

  "& .ck.ck-style-panel .ck-button": {
    color: theme.palette.text.primary,
    transition: "background 0.2s ease-in-out",
  },

  "& .ck.ck-toolbar .ck-button": {
    color: theme.palette.text.primary,
    transition: "background 0.2s ease-in-out",
  },

  "& .ck.ck-toolbar .ck-button:hover": {
    backgroundColor: theme.palette.action.hover,
  },

  "& .ck.ck-toolbar .ck-button.ck-on": {
    backgroundColor: theme.palette.action.selected,
  },

  "& .ck.ck-list-item-button__check-icon": {
    backgroundColor: "#ffffffc1",
    borderRadius: "15%",
  },
}));

const buildTheme = (palette: PaletteOptions) => {
  const base = createTheme({ palette, typography }, ptBR, ptBRDataPicker);
  return createTheme(base, { components: getComponentOverrides(base) });
};

// Temas da aplicação (menu, páginas, modais) a partir da paleta da empresa.
export const buildAppThemes = (palette: TenantPalette) => ({
  light: buildTheme(buildLightPalette(palette)),
  dark: buildTheme(buildDarkPalette(palette)),
});

const defaultAppThemes = buildAppThemes(defaultTenantPalette);
export const appLightTheme = defaultAppThemes.light;
export const appDarkTheme = defaultAppThemes.dark;

// Tema SmartTower da tela de login. O login importa `lightTheme` e não deve
// mudar junto com o tema da aplicação — por isso o nome aponta para ele.
export const loginTheme = buildTheme(loginPalette);
export const lightTheme = loginTheme;

export const themeDefault = appLightTheme;
export const themeDark = appDarkTheme;

export default appLightTheme;
